import { each, last } from "../../utils/lodash";
import { BlockModel } from "../BlockModel";
import { QuestionModel } from "../QuestionModel";
import { getSettingBoolean, getSettingNumber } from "./settingUtilities";

export const isAutoPageBreak = (block: BlockModel) => getSettingBoolean(block, "AutoPageBreak");

export const getMaxLoopSize = (block: BlockModel) => getSettingNumber(block, "MaxLoopSize", 1);

export const getAllCurrentPageQuestions = (currentBlock: BlockModel, questionIndex: number) => {
    let questions: QuestionModel[] = [];
    let foundPage = false;

    if (isAutoPageBreak(currentBlock)) {
        return currentBlock.questions.filter((q) => q.index === questionIndex);
    }

    each(currentBlock.questions, (q) => {
        questions.push(q);
        if (q.index === questionIndex) {
            foundPage = true;
        }
        if (q.isPageBreak || q.index === last(currentBlock.questions).index) {
            if (foundPage) {
                return false;
            }
            questions = [];
        }
        return undefined;
    });
    return questions;
};
